export class TimelineItem {
    public id: string;
    public text: string;
    public textPT: string;
    public year: number;
    public imageUrl: string;
}